module.exports = __webpack_public_path__ + "img/small-17.27b373d1.jpg";